<template>
  <div>
    <Breadcrumbs main="Users" title="Edit Profile"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="edit-profile">
        <div class="row">
          <div class="col-xl-6">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title mb-0">My Profile</h4>
              </div>
              <div class="card-body">
                <form @submit.prevent="handleSubmit">
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="firstName" class="form-label">First Name</label>
                        <input type="text" v-model="user.firstName" id="firstName" name="firstName" class="form-control" :class="{ 'is-invalid': submitted && $v.user.firstName.$error }" />
                        <div v-if="submitted && !$v.user.firstName.required" class="invalid-feedback">First Name is required</div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="lastName" class="form-label">Last Name</label>
                        <input type="text" v-model="user.lastName" id="lastName" name="firstName" class="form-control" :class="{ 'is-invalid': submitted && $v.user.lastName.$error }" />
                        <div v-if="submitted && !$v.user.lastName.required" class="invalid-feedback">Last Name is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="companyName" class="form-label">Company Name</label>
                    <input type="text" v-model="user.companyName" id="companyName" name="companyName" class="form-control"/>
                  </div>
                  <div class="form-group">
                    <label for="companyName" class="form-label">In what area(s) of coaching do you specialize?</label>
                    <input type="text" v-model="user.areasOfCouching" id="areasOfCouching" name="areasOfCouching" class="form-control"/>
                  </div>
                  <div class="form-group">
                    <label for="companyName" class="form-label">How many years have you been a coach? </label>
                    <input type="number" v-model="user.yearsOfCouching" id="yearsOfCouching" name="yearsOfCouching" class="form-control"/>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Do you have any coaching certifications?</label>
                    <label class="d-block" for="edo-ani">
                      <input class="radio_animated" id="edo-ani" v-model="user.hasCouchingCertifications" value="true" type="radio" name="rdo-ani"> Yes
                    </label>
                    <label class="d-block" for="edo-ani1">
                      <input class="radio_animated" id="edo-ani1" v-model="user.hasCouchingCertifications" value="false" type="radio" name="rdo-ani"> No
                    </label>
                  </div>
                  <div class="form-group related" :class="{'show': showOne}" v-if="user.hasCouchingCertifications === 'true'">
                    <label for="couchingCertifications" class="form-label">If yes, which certification(s)</label>
                    <input type="text" id="couchingCertifications" v-model="user.couchingCertifications" name="couchingCertifications" class="form-control"/>
                  </div>
                  <div class="form-group">
                    <label for="activeClientsCount" class="form-label">How many active clients do you currently have?</label>
                    <input type="number" v-model="user.activeClientsCount" id="activeClientsCount" name="activeClientsCount" class="form-control"/>
                  </div>
                  <div class="form-group">
                    <label for="averageEngagementWithClient" class="form-label">How long is an average engagement with a client? (# of weeks or months, etc.)</label>
                    <input type="text" v-model="user.averageEngagementWithClient" id="averageEngagementWithClient" name="averageEngagementWithClient" class="form-control"/>
                  </div>
                  <div class="form-group">
                    <label for="typicalClientProfile" class="form-label">How would you describe the profile of your typical client?</label>
                    <input type="text" v-model="user.typicalClientProfile" id="typicalClientProfile" name="typicalClientProfile" class="form-control"/>
                  </div>
                  <div class="form-group">
                    <label for="goalExample" class="form-label">Can you give us an example of a typical goal or personal challenge that you help your clients work through?</label>
                    <input type="text" v-model="user.goalExample" id="goalExample" name="goalExample" class="form-control"/>
                  </div>
                  <div class="form-group">
                    <label for="typeOfToolsUsed" class="form-label">What type of tool(s) do you use to help your clients achieve their goals?</label>
                    <input type="text" v-model="user.typeOfToolsUsed" id="typeOfToolsUsed" name="typeOfToolsUsed" class="form-control"/>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Do you have a specialization or methodology that you believe differentiates you from other coaches?</label>
                    <label class="d-block" for="edo-ani2">
                      <input class="radio_animated" id="edo-ani2" v-model="user.hasSpecificMethodology" value="true" type="radio" name="rdo-ani2"> Yes
                    </label>
                    <label class="d-block" for="edo-ani3">
                      <input class="radio_animated" id="edo-ani3" v-model="user.hasSpecificMethodology" value="false" type="radio" name="rdo-ani2"> No
                    </label>
                  </div>
                  <div class="form-group related" :class="{'show': showTwo}" v-if="user.hasSpecificMethodology === 'true'">
                    <label for="methodologyDescription" class="form-label">If yes, please describe that specialization or methodology.</label>
                    <input type="text" id="methodologyDescription" v-model="user.methodologyDescription" name="methodologyDescription" class="form-control"/>
                  </div>
                  <div class="form-footer">
                    <div class="loading-wrapper">
                      <div class="btn-loading" v-if="loadingProfile">
                        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                      </div>
                      <button class="btn btn-primary btn-block">Save</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-xl-6">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title mb-0">Change Profile Avatar</h4>
              </div>
              <div class="card-body">
                <div class="large-12 medium-12 small-12 cell">
                  <div class="invalid-feedback d-block" v-if="avatarError">Please select image</div>
                  <label class="update-image">File
                    <input type="file" id="fileAvatar" accept="image/x-png,image/jpeg" ref="fileAvatar" @change="handleFileUploadAvatar()"/>
                  </label>
                  <button class="btn btn-primary btn-block" @click="submitFileAvatar()" :disabled="fileAvatarLoading">{{fileAvatarLoading ? 'Loading...' : 'Save'}}</button>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header">
                <h4 class="card-title mb-0">Change Company Logo</h4>
              </div>
              <div class="card-body">
                <div class="large-12 medium-12 small-12 cell">
                  <div class="invalid-feedback d-block" v-if="logoError">Please select image</div>
                  <label class="update-image">File
                    <input type="file" id="fileLogo" accept="image/x-png,image/jpeg" ref="fileLogo" v-on:change="handleFileUploadLogo()"/>
                  </label>
                  <button class="btn btn-primary btn-block" @click="submitFileLogo()" :disabled="fileLogoLoading">{{fileLogoLoading ? 'Loading...' : 'Save'}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import {required} from "vuelidate/lib/validators";
  export default {
    data() {
      return {
        fileAvatar: '',
        avatarError: false,
        fileAvatarLoading: false,
        fileLogo: '',
        logoError: false,
        fileLogoLoading: false,
        userProfile: [],
        url: process.env.VUE_APP_URL,
        showOne: false,
        showTwo: false,
        loadingProfile: false,

        user: [],
        submitted: false,
      }
    },
    validations: {
      user: {
        firstName: { required },
        lastName: { required },
      }
    },
    mounted() {
      this.userProfile = JSON.parse(localStorage.getItem('userinfo'));

      this.user = {
        "firstName": this.userProfile.firstName,
        "lastName": this.userProfile.lastName,
        "companyName": this.userProfile.companyName,
        "areasOfCouching": this.userProfile.areasOfCouching,
        "yearsOfCouching": this.userProfile.yearsOfCouching,
        "hasCouchingCertifications": JSON.stringify(this.userProfile.hasCouchingCertifications),
        "couchingCertifications": this.userProfile.couchingCertifications,
        "activeClientsCount": this.userProfile.activeClientsCount,
        "averageEngagementWithClient": this.userProfile.averageEngagementWithClient,
        "typicalClientProfile": this.userProfile.typicalClientProfile,
        "goalExample": this.userProfile.goalExample,
        "typeOfToolsUsed": this.userProfile.typeOfToolsUsed,
        "hasSpecificMethodology": JSON.stringify(this.userProfile.hasSpecificMethodology),
        "methodologyDescription": this.userProfile.methodologyDescription
      }
    },
    methods: {
      getBase64 (file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          cb(reader.result);
        };
        reader.onerror = function (error) {
          console.log("Error: ", error);
        };
      },
      handleFileUploadAvatar(){
        this.fileAvatar = this.$refs.fileAvatar.files[0];
        this.avatarError = false;
      },
      submitFileAvatar() {
        if (this.fileAvatar) {
          this.fileAvatarLoading = true;
          this.avatarError = false;
          this.getBase64( this.fileAvatar, async (res) => {
            const payload = {
              FileName: this.fileAvatar.name,
              FileData: res.substring(res.indexOf(",") + 1),
            };
            let data = await this.$store.dispatch('uploadAvatar',  payload);
            this.fileAvatarLoading = false;
            this.$refs.fileAvatar.value = null;
            this.fileAvatar = "";
            if (data.status === 200) {
              this.$toasted.show('Saved', {
                theme: 'bubble',
                position: "bottom-right",
                type: 'success',
                duration: 1000
              });
            } else {
              this.$toasted.show(' Please try again ', {
                theme: 'bubble',
                position: "bottom-right",
                type: 'error',
                duration: 1000
              });
            }
          });
        } else {
          this.avatarError = true
        }
      },

      handleFileUploadLogo(){
        this.fileLogo = this.$refs.fileLogo.files[0];
        this.logoError = false;
      },
      submitFileLogo(){
        console.log(this.fileLogo)
        if (this.fileLogo) {
          this.fileLogoLoading = true;
          this.logoError = false;
          this.getBase64(this.fileLogo, async (res) => {
            const payload = {
              FileName: this.fileLogo.name,
              FileData: res.substring(res.indexOf(",") + 1),
            };

            let data = await this.$store.dispatch('uploadLogo',  payload);
            this.fileLogoLoading = false;
            this.$refs.fileLogo.value = null;
            if (data.status === 200) {
              this.$toasted.show('Saved', {
                theme: 'bubble',
                position: "bottom-right",
                type: 'success',
                duration: 1000
              });
            } else {
              this.$toasted.show(' Please try again ', {
                theme: 'bubble',
                position: "bottom-right",
                type: 'error',
                duration: 1000
              });
            }
          })
        } else {
          this.logoError = true
        }
      },
      handleSubmit() {
        this.submitted = true;

        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$toasted.show(' Please fill all required fields ', {
            theme: 'bubble',
            position: "bottom-right",
            type: 'error',
            duration: 4000
          });
          return;
        }

        this.loadingProfile = true;
        this.loading = true;

        this.user.hasCouchingCertifications = (this.user.hasCouchingCertifications === 'true');
        this.user.hasSpecificMethodology = (this.user.hasSpecificMethodology === 'true');
        this.user.yearsOfCouching = Number(this.user.yearsOfCouching);
        this.user.activeClientsCount = Number(this.user.activeClientsCount);

        if (!this.user.hasCouchingCertifications) this.user.couchingCertifications = null;
        if (!this.user.hasSpecificMethodology) this.user.methodologyDescription = null;

        let val = localStorage.getItem('token');
        this.$store.dispatch('updateProfile', this.user).then((res) => {
          this.$store.dispatch('getUser', val).then(() => {
            if (res.status === 200) {
              this.$toasted.show('Saved', {
                theme: 'bubble',
                position: "bottom-right",
                type: 'success',
                duration: 1000
              });
              setTimeout(()=> {
                this.loadingProfile = false;
                window.location.reload();
              }, 1000)
            } else {
              this.loadingProfile = false;
              this.$toasted.show(' Please try again ', {
                theme: 'bubble',
                position: "bottom-right",
                type: 'error',
                duration: 1000
              });
            }
          });
        });

      }
    },
    computed: {
      hasCouchingCertificationsShow() {
        return this.user.hasCouchingCertifications;
      },
      hasSpecificMethodologyShow() {
        return this.user.hasSpecificMethodology;
      },
      users () {
        return this.$store.state.users
      }
    },
    watch: {
      hasCouchingCertificationsShow() {
        this.showOne = true;
        setTimeout(() => {
          this.showOne = false;
        }, 500)
      },
      hasSpecificMethodologyShow() {
        this.showTwo = true;
        setTimeout(() => {
          this.showTwo = false;
        }, 500)
      }
    }
  }
</script>
<style scoped lang="scss">
  .update-image {
    width: 100%;
    margin-bottom: 15px;
    border: 1px solid #f8f8f8;
    padding: 10px 20px;
    background: #f8f8f8;
    border-radius: 5px;
    color: #31366f;
  }
  .related {
    margin: -10px;
    margin-bottom: 0.5rem !important;
    padding: 10px 10px 0.5rem 10px;
    transition: 0.5s;
    border-radius: 0.25rem;

    &.show {
      background: #f8efd1;
    }
  }
  .loading-wrapper {
    position: relative;

    button {
      width: 100%;
    }

    .btn-loading {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      background: rgba(255, 255, 255, 0.55);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .lds-ring {
      display: inline-block;
      position: relative;
      width: 25px;
      height: 25px;
    }
    .lds-ring div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 25px;
      height: 25px;
      border: 3px solid #fff;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #fff transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
      animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
      animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
      animation-delay: -0.15s;
    }
    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
</style>
